import PrintTemplate from 'react-print'
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import DisplayDelivery from './DisplayDelivery'
import moment from 'moment'
import {formatPrice,formatQuantity} from '../helpers/helpers'


class DrPrint extends Component{
    render() {
        return (
            <PrintTemplate>
	            <div className="forDrPrintWrap">
	            	<div className="drQuote">
	            		<p><span>{this.props.quoteNumber}</span></p>
	            	</div>
	            	<div className="row">          
		                <div className="drLeft">
		                	<span>{this.props.name}</span>
		                </div>
		                <div className="drRight">
		                	<span>{moment().format("MMMM DD, YYYY")}</span>
		                </div>
		            </div>
		            <div className="row">
		                <div className="drLeft">
		                	<span>...</span>
		                </div>
		                <div className="drRight">
		                	<span>...</span>
		                </div>
		            </div>
	                <div className="drAdress">
	                	<span>{this.props.address}</span>
	                </div>
	                <div className="drMarginTable">
		                <table className="table tablePrint">
			                <thead>
			                    <tr>               
			                        <th className="text-center printHeader"></th>
			                        <th className="text-center printHeader"></th>
			                        <th className="text-center printHeader"></th>
			                        
			                    </tr>
			                </thead>
			                <tbody>
			                    {
			                        this.props.products &&
			                            Object.keys(this.props.products).map(function (key){
			                                let list = this.props.products[key]
			                                return (<tr>
			                                			<td className="drQty">
			                                				{formatQuantity(list.productNumber)}
			                                			</td>
			                                			<td className="drUnit">
			                                				{list.productUnit}
			                                			</td>
			                                			<td className="drName">
			                                				{list.productName}
			                                			</td>
			                                		</tr>)
			                           }.bind(this))
			                    }
			                </tbody>
			            </table>
		            </div>
		        </div>
			</PrintTemplate>
        );
    }
};

export default DrPrint;


// WEBPACK FOOTER //
// ./src/components/DrPrint.js